<template>
  <div class="modules-tenders-tabs-container">
    <Sticky v-model="isStickyHeader">
      <ul
        id="sticky-tabs"
        v-show="isStickyHeader"
        class="tabs hkld-tabs"
        data-tabs
      >
        <div>
          <div
            id="tabs-nav"
            class="tabs-title sticky-tabs-nav"
          >
            <a
              v-checkVisibility
              @click="navToTab('#tab-general', $event)"
              class="is-active-tab"
              :class="{ errorTab: tabsInvalid.generalInvalid }"
            >{{ $t('tender.generalTab') }}</a>
            <a
              v-checkVisibility
              @click="navToTab('#tab-scope', $event)"
              v-show="isTender"
            >{{ $t('tender.scopeTab') }}</a>
            <a
              v-checkVisibility
              @click="navToTab('#tab-services', $event)"
              :class="{ errorTab: tabsInvalid.sectionInvalid }"
            >{{ $t('tender.sectionTab') }}</a>
            <a
              v-checkVisibility
              @click="navToTab('#tab-attachment', $event)"
            >{{ $t('tender.attachmentTab') }}</a>
            <a
              v-checkVisibility
              @click="navToTab('#tab-tnc', $event)"
              :class="{ errorTab: tabsInvalid.termsInvalid }"
            >{{ $t('tender.tncTab') }}</a>
            <a
              v-checkVisibility
              @click="navToTab('#tab-query', $event)"
              v-show="showQueryTab"
            >{{ $t('summary.query.name') }}</a>
          </div>
          <div class="float-right sticky-tender-tab-buttons">
            <slot />
          </div>
        </div>
      </ul>
    </Sticky>

    <div class="create-tender-main">
      <ul
        id="tender-tabs"
        class="row tabs hkld-tabs medium-column-5"
        data-tabs
      >
        <li class="tabs-title is-active column">
          <a
            :class="{ errorTab: tabsInvalid.generalInvalid }"
            href="#tab-general"
            v-checkVisibility
            @click="syncHighlight(0)"
          >{{ $t('tender.generalTab') }}</a>
        </li>
        <li
          class="tabs-title column"
          v-show="isTender"
          @click="syncHighlight(1)"
        >
          <a
            href="#tab-scope"
            v-checkVisibility
          >{{ $t('tender.scopeTab') }}</a>
        </li>
        <li
          class="tabs-title column"
          @click="syncHighlight(2)"
        >
          <a
            :class="{ errorTab: tabsInvalid.sectionInvalid }"
            href="#tab-services"
            v-checkVisibility
          >{{ $t('tender.sectionTab') }}</a>
        </li>
        <li
          class="tabs-title column"
          @click="syncHighlight(3)"
        >
          <a
            href="#tab-attachment"
            v-checkVisibility
          >{{ $t('tender.attachmentTab') }}</a>
        </li>
        <li
          class="tabs-title column"
          @click="syncHighlight(4)"
        >
          <a
            :class="{ errorTab: tabsInvalid.termsInvalid }"
            href="#tab-tnc"
            v-checkVisibility
          >{{ $t('tender.tncTab') }}</a>
        </li>
        <li
          class="tabs-title column"
          @click="syncHighlight(5)"
          v-show="showQueryTab"
        >
          <a
            href="#tab-query"
            v-checkVisibility
          >{{ $t('summary.query.name') }}</a>
        </li>
      </ul>

      <div
        data-tabs-content="tender-tabs"
        class="hkld-tabs-content"
      >
        <div
          class="tabs-panel is-active"
          id="tab-general"
        >
          <div class="grey lighten-5">
            <slot name="general" />
          </div>
        </div>
        <div
          class="tabs-panel"
          id="tab-scope"
          v-show="isTender"
        >
          <div class="grey lighten-5">
            <slot name="scopeOfWork" />
          </div>
        </div>
        <div
          class="tabs-panel"
          id="tab-services"
        >
          <div class="grey lighten-5">
            <slot name="itemServices" />
          </div>
        </div>
        <div
          class="tabs-panel"
          id="tab-attachment"
        >
          <div class="grey lighten-5">
            <slot name="fileUpload" />
          </div>
        </div>
        <div
          class="tabs-panel"
          id="tab-tnc"
        >
          <div class="grey lighten-5">
            <slot name="termsConditions" />
          </div>
        </div>
        <div
          class="tabs-panel"
          id="tab-query"
          v-show="showQueryTab"
        >
          <div class="grey lighten-5">
            <slot name="query" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from '@/utils/eventBus'
import Sticky from '@/controls/Sticky'
import { fusionInputCheckUtil } from '@/plugin/FusionInputCheck'

export default {
  name: 'tender-tabs-container',
  components: {
    Sticky,
  },
  props: {
    isTender: {
      type: Boolean,
      default: true,
    },
    tabsInvalid: {
      type: Object,
      default () {
        return {
          generalInvalid: false,
          sectionInvalid: false,
          termsInvalid: false,
        }
      },
    },
    showQueryTab: {
      type: Boolean,
      default: false,
    },
  },
  mounted () {
    if (!this.tenderTabs) {
      this.tenderTabs = new Foundation.Tabs($('#tender-tabs'))
    }
    $('#tender-tabs li a')[0].click()
  },
  data () {
    return {
      isStickyHeader: false,
    }
  },
  methods: {
    navToTab (tabElem, event) {
      EventBus.emit('switchTab', $(event.target).index())
      setTimeout(() => {
        fusionInputCheckUtil.refreshFieldTips()
      }, 0)
      $('#tender-tabs').foundation('selectTab', tabElem, false)
      $(event.target).siblings().removeClass('is-active-tab')
      $(event.target).addClass('is-active-tab')
      let tabPosition = $('#tender-tabs').offset().top
      $(window).scrollTop(Number(tabPosition))
    },
    syncHighlight (index) {
      EventBus.emit('switchTab', index)
      setTimeout(() => {
        fusionInputCheckUtil.refreshFieldTips()
      }, 0)
      $('#tabs-nav').children().removeClass('is-active-tab')
      $('#tabs-nav a').eq(index).addClass('is-active-tab')
    },
  },
  destroyed () {
    if (this.tenderTabs) {
      this.tenderTabs.destroy()
    }
  },
}
</script>

<style lang="scss" scoped>
@import "~styles/tender/view";
@import "~styles/tabsContainer";
@import "~styles/stickyBtn";
.modules-tenders-tabs-container {
  background: white;
}
</style>
